import React from 'react';
import Icon from '../../../components/AppIcon';

const AlertCard = ({ alert, onDismiss, onViewDetails }) => {
  const severityConfig = {
    critical: {
      bgColor: 'bg-error/10',
      borderColor: 'border-error',
      iconColor: 'text-error',
      icon: 'AlertTriangle'
    },
    high: {
      bgColor: 'bg-warning/10',
      borderColor: 'border-warning',
      iconColor: 'text-warning',
      icon: 'AlertCircle'
    },
    medium: {
      bgColor: 'bg-accent/10',
      borderColor: 'border-accent',
      iconColor: 'text-accent',
      icon: 'Info'
    },
    low: {
      bgColor: 'bg-info/10',
      borderColor: 'border-info',
      iconColor: 'text-info',
      icon: 'Bell'
    }
  };

  const config = severityConfig?.[alert?.severity] || severityConfig?.low;

  return (
    <div className={`${config?.bgColor} border-l-4 ${config?.borderColor} p-4 rounded-lg mb-4 animation-organic`}>
      <div className="flex items-start gap-4">
        <div className={`${config?.iconColor} mt-1`}>
          <Icon name={config?.icon} size={24} />
        </div>
        
        <div className="flex-1">
          <div className="flex items-start justify-between mb-2">
            <div>
              <h3 className="text-foreground font-semibold text-lg">{alert?.title}</h3>
              <p className="text-muted-foreground text-sm">{alert?.zone} • {alert?.timestamp}</p>
            </div>
            {alert?.dismissible && (
              <button
                onClick={() => onDismiss(alert?.id)}
                className="text-muted-foreground hover:text-foreground animation-organic"
                aria-label="Dismiss alert"
              >
                <Icon name="X" size={20} />
              </button>
            )}
          </div>
          
          <p className="text-foreground mb-3">{alert?.description}</p>
          
          {alert?.actions && alert?.actions?.length > 0 && (
            <div className="flex flex-wrap gap-2 mb-3">
              {alert?.actions?.map((action, index) => (
                <span
                  key={index}
                  className="text-xs px-3 py-1 bg-card rounded-full text-card-foreground"
                >
                  {action}
                </span>
              ))}
            </div>
          )}
          
          <div className="flex items-center gap-4 text-sm">
            <button
              onClick={() => onViewDetails(alert)}
              className="text-primary hover:text-primary/80 font-medium animation-organic flex items-center gap-1"
            >
              View Details
              <Icon name="ChevronRight" size={16} />
            </button>
            
            {alert?.affectedVisitors && (
              <span className="text-muted-foreground flex items-center gap-1">
                <Icon name="Users" size={16} />
                {alert?.affectedVisitors} affected
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlertCard;